import { render, staticRenderFns } from "./BillTick.vue?vue&type=template&id=2d60e4c6&scoped=true"
import script from "./BillTick.vue?vue&type=script&lang=js"
export * from "./BillTick.vue?vue&type=script&lang=js"
import style0 from "./BillTick.vue?vue&type=style&index=0&id=2d60e4c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d60e4c6",
  null
  
)

export default component.exports